import { render, staticRenderFns } from "./socialResponsibility.vue?vue&type=template&id=5a79fa93"
import script from "./socialResponsibility.vue?vue&type=script&lang=js"
export * from "./socialResponsibility.vue?vue&type=script&lang=js"
import style0 from "./socialResponsibility.vue?vue&type=style&index=0&id=5a79fa93&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports